import { StoreDetailsModel } from "./StoreDetailsModel";
import { BrandingModel } from "./BrandingModel";
import { LoginPageModel } from "./LoginPageModel";
import { ProductMappingModel } from "./ProductMappingModel";

export interface SwagstoreSettingsModel {
  storeDetails: StoreDetailsModel;
  branding: BrandingModel;
  loginPage: LoginPageModel;
  productMapping: ProductMappingModel;
}

export const createEmptySwagstoreSettings = (): SwagstoreSettingsModel => ({
  storeDetails: {
    store_id: undefined,
    store_name: "",
    customer_name: "",
    is_public: true,
    domains: [],
    customer_id: 0,
    authentication_method_ids: [],
  },
  branding: {
    // bannerImage: null,
    carouselImages: null,
    logo: null,
    favicon: null,
    primaryColor: "#1553CA",
    secondaryColor: "#D7458F",
    storeBackgroundColor: "#FFFFFF",
    textFieldActiveColor: "#FFFFFF",
    textFieldDisabledColor: "rgba(230, 230, 230, 1)",
    productHeadingText: "All Products",
  },
  loginPage: {
    loginPageImage: null,
  },
  productMapping: {
    productPrices: {},
    bulkUpdateEnabled: false,
    markupPercentage: 0,
    discountUpdateEnabled: false,
    discountPercentage: 0,
    selectedInventoryProducts: [],
    selectedCatalogueProducts: [],
    csvFile: null,
  },
});
